import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="shared--tabbar"
export default class extends Controller {
  connect() {
    const urlParams = new URLSearchParams(window.location.search);
    const tabParam = urlParams.get("tab");

    if (tabParam) {
      const tabLink = this.element.querySelector(`a[href="#${tabParam}"]`);
      if (tabLink) {
        this.deactivateTabs();
        this.activateTab(tabLink, tabParam);
      }
    }
  }

  onClickChangeTab(event) {
    event.preventDefault();
    const tabId = event.target.href.split("#")[1];

    this.deactivateTabs();
    this.activateTab(event.target, tabId);

    const url = new URL(window.location);
    url.searchParams.set("tab", tabId);
    window.history.pushState({}, "", url);
  }

  // Nur die eigene Leiste + die von ihr referenzierten Panes zurücksetzen.
  // Das frühere dokumentweite `.active`-Strippen räumte auch fremde
  // Komponenten ab (z.B. die aktiven React-Property-Tabs im
  // Dateiprofil-Editor innerhalb eines Panes, #62).
  deactivateTabs() {
    this.element
      .querySelectorAll(".active")
      .forEach((tab) => tab.classList.remove("active"));

    this.element.querySelectorAll('a[href^="#"]').forEach((link) => {
      const pane = document.getElementById(link.getAttribute("href").slice(1));
      if (pane && pane.classList.contains("tab-pane")) {
        pane.classList.remove("active");
        pane.classList.add("hidden");
      }
    });
  }

  activateTab(tabLink, tabId) {
    tabLink.parentElement.classList.add("active");
    const targetPane = document.getElementById(tabId);
    if (targetPane) {
      targetPane.classList.add("active");
      targetPane.classList.remove("hidden");
    }
  }
}
